import { css, keyframes, useTheme } from '@emotion/react';

const iconStyle = css`
  overflow: visible;
`;

const rotateAnimation = keyframes`
  0% {
    transform: rotate(20deg);
  };
  50% {
    transform: rotate(-20deg);
  };
  100% {
    transform: rotate(20deg);
  };
`;

const scaleRotateAnimation = keyframes`
  0% {
    transform: rotate(-20deg);
  };
  50% {
    transform: rotate(20deg);
  };
  100% {
    transform: rotate(-20deg);
  };
`;

const beamStyle = css`
  transform-origin: center 76px;
  transform: rotate(20deg);
`;

const beamAnimatedStyle = css`
  animation: ${rotateAnimation} 3s infinite cubic-bezier(0.6, -0.28, 0.74, 0.05);
`;

const scaleLeftStyle = css`
  transform-origin: 56px 76px;
  transform: rotate(-20deg);
`;

const scaleRightStyle = css`
  transform-origin: 200px 76px;
  transform: rotate(-20deg);
`;

const scaleAnimatedStyle = css`
  animation: ${scaleRotateAnimation} 3s infinite cubic-bezier(0.67, 0.09, 0.77, 0.42);
`;

export interface ScalesProps {
  size?: number;
  strokeWidth?: number;
  color?: string;
  animate?: boolean;
}

export const Scales = ({ size = 36, strokeWidth = 16, color = undefined, animate = false }: ScalesProps) => {
  const theme = useTheme();
  color = color || theme.color.grey[100];
  return (
    <svg viewBox="0 0 256 256" xmlns="http://www.w3.org/2000/svg" width={size} height={size} css={iconStyle}>
      <g css={[beamStyle, animate && beamAnimatedStyle]}>
        <path d="M56 76H200" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
        <g css={[scaleLeftStyle, animate && scaleAnimatedStyle]}>
          <path d="M24 156C24 173.67 44 180 56 180C68 180 88 173.67 88 156L56 76L24 156Z" fill={color} opacity="0.2" />
          <path
            d="M24 156C24 173.67 44 180 56 180C68 180 88 173.67 88 156L56 76L24 156Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
        </g>
        <g css={[scaleRightStyle, animate && scaleAnimatedStyle]}>
          <path d="M168 156C168 173.67 188 180 200 180C212 180 232 173.67 232 156L200 76L168 156Z" fill={color} opacity="0.2" />
          <path
            d="M168 156C168 173.67 188 180 200 180C212 180 232 173.67 232 156L200 76L168 156Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
        </g>
      </g>
      <path d="M128 40V216" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M104 216H152" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
